exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: 'Gugi';\n  src: url(" + require("./Gugi-Regular.ttf") + ") format(\"truetype\"); }\n\n.footer {\n  font-family: 'Gugi', cursive;\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  background-color: #f8001690;\n  letter-spacing: 4px;\n  color: white;\n  text-align: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/footer/Footer.scss
// module id = 179
// module chunks = 0